function getTranslucentLayerCSS(background, zIndex, borderRadius) {
  return (
    `&:after {
      content: ' ';
      position: absolute; top: 0; bottom: 0; right: 0; left: 0;
      background: ${background};
      z-index: ${zIndex};
    }`
  );
}

export default getTranslucentLayerCSS;
